@if (showLegend) {
  <div class="legend">
    @for (item of filteredLegendItems; track item.label) {
      <div class="legend-item">
        <span class="legend-dot" [style.background-color]="item.color"></span>
        <cs-label class="legend-label">{{ item.label }}</cs-label>
      </div>
    }
  </div>
}
<div class="chart-container">
  <canvas #chartCanvas></canvas>
  @if (isLoading) {
    <div class="loading-overlay">
      <cs-spinner></cs-spinner>
    </div>
  }
</div>
@if (showTrendLegend) {
  <cs-trend-legend></cs-trend-legend>
}
